import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DownloadIcon from '@material-ui/icons/GetApp';
import MapIcon from '@material-ui/icons/Map';
import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles({
    root: {
        width: 220,
        margin: 15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    media: {
        width: 200,
        height: 120,
    },
});

export default function MediaCard({ identifier, title, abstract, url, produsen, download, view, setOpen }) {
    const classes = useStyles();

    function shorten(str, maxLen, separator = ' ') {
        if (str.length <= maxLen) return str;
        return str.substr(0, str.lastIndexOf(separator, maxLen)) + " ...";
    }

    return (
        <Card className={classes.root} key={identifier+" "+title}>
            <CardActionArea>
                <CardMedia
                    className={classes.media}
                    image={url ? url : "https://geoservices.big.go.id/raster/rest/services/IMAGERY/FU_2011_KotaPekanbaru/ImageServer/info/thumbnail"}
                    title="Contemplative Reptile"
                />
                <CardContent>
                    <Typography gutterBottom variant="body2" color="primary">
                        {title ? title : 'Title'}
                    </Typography>
                    <Typography display="block" variant="caption" color="textSecondary">
                        {abstract ? shorten(abstract, 60)  : 'Abstract'}
                    </Typography>
                    {
                        /*
                    <Typography display="block" variant="caption" color="text.secondary">
                        {produsen ? produsen : 'Organization'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {view} Views • Published {} ago
                    </Typography> 
                    */
                    }

                    <Typography gutterBottom variant="h5" component="h2">
                       
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions style={{display: 'flex', justifyContent: 'center', background:'#eff'}}>
                <Button size="small" color="primary" startIcon={<MapIcon />} onClick={()=>setOpen(identifier)}>
                    Lihat detail
                </Button>
                {
                /*
                <Button size="small" color="primary" startIcon={<DescriptionIcon />}>
                    Metadata
                </Button>
                 { download &&
                <Button size="small" color="primary" startIcon={<DownloadIcon />}>
                    Data
                </Button>
                }
                */
                }
               
            </CardActions>
        </Card>
    );
}